import {
  animate,
  animateChild,
  query,
  sequence,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';

export function rollUpAnimation(
  triggerName = 'rollUpDefault',
  maxHeight = '0rem',
  entryConfig = '0s',
  exitConfig = '0s'
) {
  return [
    trigger(triggerName, [
      transition('void => *', [
        style({
          maxHeight: '0rem',
          overflow: 'hidden',
          marginBottom: 0,
          marginTop: 0,
        }),
        animate(entryConfig, style({ maxHeight, marginBottom: '*', marginTop: '*' })),
        sequence([
          style({ maxHeight: '50rem', overflow: 'visible' }),
          query('@items', stagger(50, animateChild()), {
            optional: true,
            delay: 0,
          }),
        ]),
      ]),
      transition('* => void', [
        style({
          maxHeight,
          overflow: 'hidden',
          marginBottom: '*',
          marginTop: '*',
        }),
        animate(exitConfig, style({ maxHeight: '0rem', marginBottom: 0, marginTop: 0 })),
      ]),
    ]),
  ];
}
